export const track3DSV2Initialised = (paymentFlow) => ({
    event: '3DS V2 initialised',
    effect: 'initialise 3DS V2 flow',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'payment'
    },
    attributes: {
        paymentFlow
    }
})

export const track3DSV2Fingerprint = () => ({
    event: '3DS V2 fingerprint',
    effect: 'proceed to challenge',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'payment'
    }
})

export const track3DSV2Challenge = () => ({
    event: '3DS V2 challenge',
    effect: 'proceed to take payment',
    category: {
        primaryCategory: 'checkout',
        subCategory: 'payment'
    }
})
